import React from 'react';
import { fromMarkdown } from '@lib/utils';
import BundleProductsT, {
  BundleProductT,
} from '@factories/RowFactory/components/BundleProducts/types';
import {
  StyledBundleProducts,
  BundleProductsContainer,
} from '@factories/RowFactory/components/BundleProducts/styled/StyledBundleProducts';
import BundleProductCard from '@factories/RowFactory/components/BundleProducts/BundleProductCard';
import usePromotionsContext from '@hooks/usePromotionsContext';
import usePostcodeContext from '@hooks/usePostcodeContext';

export const BundleProducts = ({ display, title, subtitle, items, products }: BundleProductsT) => {
  const { promotions } = usePromotionsContext();
  const { postcodeItem } = usePostcodeContext();

  if (!display) return null;

  return (
    <StyledBundleProducts className="container">
      <h2>{title}</h2>
      {subtitle && <h3>{fromMarkdown({ text: subtitle, isHeading: false })}</h3>}

      <BundleProductsContainer>
        {items.map((item: BundleProductT) => (
          <BundleProductCard
            key={`bundle-product-${item.id}`}
            item={item}
            products={products}
            promotions={promotions}
            coverage={postcodeItem?.coverage}
          />
        ))}
      </BundleProductsContainer>
    </StyledBundleProducts>
  );
};
